import { mapState } from 'vuex';
import f from "@/application/shared/functions.js"

import footerComponent from '../footerComponent/index.vue'


export default {
	name: 'Authorization',

	components : {
		footerComponent
	},


	data : function(){

		return {
			login : '',
			password : '',
			loading : false
		}

	},

	created : function(){
		this.login = this.$store.state.lastlogin || ''
	},

	watch: {
		//$route: 'getdata'
	},

	computed: mapState({
		auth : state => state.auth,
	}),

	methods : {

		focusedLogin : function(){
		},
	  
		signin : function(){

			this.$store.commit('lastlogin', this.login)

			this.core.api.clearCache()

			this.core.user.signin({

				password_value : this.password,
				login_value :  this.login

			}).then(state => {

				this.$router.push('/').catch(e => {})

			}).catch(e => {

				///TODO_TEXTS

				if(e.code == '401' || e.code == 511){

					this.core.sitemessage(this.$t('app.wrongname'))

					return
				}

				if(e.code == 20){
					this.$store.commit('icon', {
						icon: 'error',
						message: this.$t('app.connection')
					})

					return 
				}

				
				this.$store.commit('icon', {
					icon: 'error',
					message: this.$t('app.wentwrong')
				})
			})

		},

		keyuplogin : function(v){
			this.login = v.target.value
		},

		changelogin : function(v){
			this.login = v.target.value
		},


		registration : function(){
			this.$router.push('/registration').catch(e => {})
		},

		
	},

	props: {
		caption : String
	},

}